module.exports = __webpack_public_path__ + "static/media/iris-scan.49046e83.svg";